import React, { useContext } from "react";
import { CSContext } from "../contexts/CSContext";
import { toast } from "react-toastify";

function CSCreateButton(props: any) {
    const { setPivotVersionList } = useContext(CSContext)

    return (
        <div className="tw-flex tw-m-2 tw-justify-end">
            <button className="button-style "
                onClick={() => {
                    if (props?.selectedIndex === undefined || props?.selectedIndex === null) toast.info("select one of the versions from the table")
                    else setPivotVersionList([]);
                }}
            >Create Version</button>
        </div>
    );
}

export default CSCreateButton